export const ProductLine = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  CMS: 'CMS',
  OPERATIONS: 'OPERATIONS',
  COMMERCE: 'COMMERCE'
};
export const AllProductLines = [ProductLine.MARKETING, ProductLine.SALES, ProductLine.SERVICE, ProductLine.CMS, ProductLine.OPERATIONS, ProductLine.COMMERCE];